import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  declare linkTarget: HTMLAnchorElement;

  openLink(event: MouseEvent) {
    event.preventDefault(); // デフォルトのクリック動作を無効化

    const form = this.element as HTMLFormElement;
    form.submit();

    const url = this.linkTarget.href;
    if (url) {
      window.open(url, "_blank");
    }
  }
}
